<template>
  <div class="bs-card-menu" :class="[options.theme]" @click="$emit('click')">
    <div class="bs-overlay" :class="{overlay:!overlay}"></div>
    <div class="bs-card-head">
      <h3 class="bs-card-name"><i>{{options.name}}</i><span v-if="status" :class="[options.statusClass]">{{options.statusText}}</span></h3><h3 class="bs-card-price">{{options.currencySymbol}}{{options.price}}<span>/{{options.cycle}}</span></h3>
    </div>
    <p class="bs-card-content">{{options.introduction}}</p>
  </div>
</template>

<script>
export default {
  name: "BsCardMenu",
  components: {},
  props: {
    type: {
      type: String,
    },
    overlay:{
      type:Boolean,
      default:false,
    },
    status:{
      type:Boolean,
      default:false,
    },
    options:{
      type:Object,
      default:function(){
        return {}
      }
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>


// WEBPACK FOOTER //
// src/components/packages/cardmenu/src/cardmenu.vue